// Until the first navigation completes, currentRoute is the start route with an empty query.
const getInitialRouteQuery = (router) => new Promise((resolve) => {
  const resolveWithCurrentQuery = () => resolve({ ...router.currentRoute.query });
  router.onReady(resolveWithCurrentQuery, resolveWithCurrentQuery);
});

export default getInitialRouteQuery;
